import { removeSpecialCharsAndEmojis } from './cleanText';

/**
 * Controla el cambio de un input con límite de caracteres, actualiza el valor y gestiona errores.
 *
 * @param {Object} params
 * @param {Event} params.event - Evento onChange del input.
 * @param {Function} params.setValue - Función de react-hook-form para setear valores.
 * @param {Function} params.setError - Setter de estado para error del campo.
 * @param {number} params.maxLength - Límite máximo de caracteres permitidos.
 * @param {string} params.fieldName - Nombre del campo (ej. 'description' o 'title').
 */
const handleLimitedInputChange = ({ event, setValue, setError, maxLength, fieldName }) => {
  const inputValue = event.target.value;

  // Si el input está vacío, limpiamos todo
  if (inputValue.trim() === '') {
    setValue(fieldName, undefined, { shouldDirty: true });
    setError(false);
    return;
  }

  // Solo aplicamos limpieza si no hay composición activa. event.isComposing indica si el usuario está escribiendo caracteres compuestos (como acentos)
  // isComposing es true automáticamente al ingresar un caracter que genera un acento (ej.: "'"), al combinarse con otra letra (ej.: "a") isComposing es false (resultado: "á")
  const shouldClean = !event.isComposing;

  const processedValue = shouldClean ? removeSpecialCharsAndEmojis(inputValue) : inputValue;
  const finalValue = processedValue.slice(0, maxLength);

  setValue(fieldName, finalValue, { shouldDirty: true });

  // Validamos la longitud solo con el texto procesado
  const cleanLength = shouldClean ? processedValue.length : removeSpecialCharsAndEmojis(inputValue).length;

  if (cleanLength > maxLength) {
    setError('maxLength');
  } else {
    setError(false);
  }
};

export default handleLimitedInputChange;
